/**
 * Compre Junto (bundle): lê variantes selecionadas nos cards, atualiza total e adiciona todos ao carrinho.
 */
(function () {
  const CART_UPDATE = 'cart:update';
  const VARIANT_UPDATE = 'variant:update';

  function getSectionRoot(container) {
    return container.closest('[data-compre-junto]');
  }

  function getSelectedVariantIdFromCard(cardWrapper) {
    const productCard = cardWrapper.querySelector('product-card');
    if (productCard && typeof productCard.getSelectedVariantId === 'function') {
      const id = productCard.getSelectedVariantId();
      if (id) return id;
    }
    const checked = cardWrapper.querySelector('input[type="radio"]:checked[data-variant-id]');
    if (checked && checked.dataset.variantId) return checked.dataset.variantId;
    return cardWrapper.dataset.initialVariantId || null;
  }

  function formatMoney(cents, currencySymbol) {
    if (cents == null || isNaN(cents)) return currencySymbol + '0,00';
    const value = (cents / 100).toFixed(2);
    const [intPart, decPart] = value.split('.');
    const withDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (currencySymbol || '') + withDots + ',' + decPart;
  }

  function updateTotal(sectionRoot) {
    const totalEl = sectionRoot.querySelector('[data-compre-junto-total]');
    const cards = sectionRoot.querySelectorAll('[data-compre-junto-card]');
    const symbol = sectionRoot.dataset.currencySymbol || '';
    let totalCents = 0;

    cards.forEach((wrapper) => {
      const variantId = getSelectedVariantIdFromCard(wrapper);
      const initialPrice = wrapper.dataset.initialPrice;
      let cents = initialPrice ? parseInt(initialPrice, 10) : 0;
      if (isNaN(cents)) cents = 0;

      const priceEl = wrapper.querySelector('product-price .price, [ref="priceContainer"] .price, .product-card__content .price');
      if (priceEl && priceEl.textContent) {
        const priceText = priceEl.textContent.trim().replace(/\s+/g, '');
        const brFormat = priceText.match(/([\d.,]+)/);
        if (brFormat) {
          const numStr = brFormat[1].replace(/\./g, '').replace(',', '.');
          const value = parseFloat(numStr);
          if (!isNaN(value)) cents = Math.round(value * 100);
        }
      }

      if (cents > 0) {
        totalCents += cents;
      }
    });

    if (totalEl) totalEl.textContent = formatMoney(totalCents, symbol);
  }

  function setupVariantListeners(sectionRoot) {
    sectionRoot.querySelectorAll('[data-compre-junto-card]').forEach((wrapper) => {
      const card = wrapper.querySelector('product-card');
      if (card) {
        card.addEventListener(VARIANT_UPDATE, () => updateTotal(sectionRoot));
      }
    });
  }

  async function handleBuyClick(sectionRoot, button) {
    const cards = sectionRoot.querySelectorAll('[data-compre-junto-card]');
    const items = [];
    let hasUnavailable = false;

    cards.forEach((wrapper) => {
      const variantId = getSelectedVariantIdFromCard(wrapper);
      if (variantId) {
        items.push({ id: variantId, quantity: 1 });
      } else {
        hasUnavailable = true;
      }
    });

    if (hasUnavailable || items.length === 0) {
      button.disabled = false;
      return;
    }

    const cartAddUrl =
      (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    button.disabled = true;
    const originalText = button.textContent;

    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok && !data.status) {
        document.dispatchEvent(
          new CustomEvent(CART_UPDATE, {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: sectionRoot.dataset.sectionId || '',
              data: { source: 'compre-junto', itemCount: data.item_count },
            },
          })
        );
      } else {
        const message = data.message || data.description || 'Não foi possível adicionar ao carrinho.';
        if (typeof window.alert === 'function') window.alert(message);
      }
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.compreJuntoInit === 'true') return;
    sectionRoot.dataset.compreJuntoInit = 'true';

    updateTotal(sectionRoot);
    setupVariantListeners(sectionRoot);

    const button = sectionRoot.querySelector('[data-compre-junto-buy]');
    if (button) {
      button.addEventListener('click', () => {
        handleBuyClick(sectionRoot, button);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-compre-junto]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sectionRoot = e.target.querySelector('[data-compre-junto]');
    if (sectionRoot) initSection(sectionRoot);
  });

  // Quando o product-recommendations substitui o innerHTML, o novo [data-compre-junto] precisa ser inicializado
  const observer = new MutationObserver(() => {
    document.querySelectorAll('[data-compre-junto]:not([data-compre-junto-init])').forEach(initSection);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
